import React, { useEffect, useState, useCallback, useMemo } from "react";
import IssListPage from "../../../../../../presentation/pages/admin/iss/list";
import { makeRemoteIss } from "../../../../usecases/iss/remote-iss-factory";
import { IssResponseModel } from "../../../../../../domain/models/iss";
import { FilterType } from "../../../../../../presentation/pages/admin/iss/list/type";
import toastUtils from "../../../../../../utils/ToastUtils";

const MakeIssList: React.FC = () => {
  const [list, setList] = useState<IssResponseModel>();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<FilterType>({ page: 0, size: 10 });

  const issService = useMemo(() => makeRemoteIss(), []);

  const handleReload = useCallback(async (newFilters: FilterType) => {
    try {
      setLoading(true);
      const updatedFilters = { ...filters, ...newFilters };
      setFilters(updatedFilters);
      
      const response = await issService.filter(updatedFilters);
      setList(response);
    } catch (error) {
      toastUtils.showMessage({
        type: "error",
        message: "Erro ao carregar listagem de ISS.",
      });
    } finally {
      setLoading(false);
    }
  }, [filters, issService]);

  const handleDelete = useCallback(async (id: number) => {
    try {
      setLoading(true);
      await issService.delete(id);
      toastUtils.showMessage({
        type: "success",
        message: "ISS excluído com sucesso!",
      });
      handleReload({ page: 0 });
    } catch (error) {
      toastUtils.showMessage({
        type: "error",
        message: "Erro ao excluir ISS.",
      });
    } finally {
      setLoading(false);
    }
  }, [issService, handleReload]);

  useEffect(() => {
    handleReload(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IssListPage
      list={list}
      loading={loading}
      handleReload={handleReload}
      handleDelete={handleDelete}
    />
  );
};

export default MakeIssList;
